import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import { Pagination } from 'components';

import { RENTAL_ITEMS } from 'graphql/queries/rental-items';

import {
  Typography,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Button
} from '@material-ui/core';

import {
  CircularLoader,
} from 'components';

import useStyles from './styles';

const headingsConfig = classes => {
  return [
    { label: 'Photo', align: 'left', cellClassName: classes.imgCell },
    {
      label: 'Rental Items',
      cellClassName: classes.nameCell,
      align: 'left'
    },
    {
      label: 'Available Units ',
      cellClassName: classes.participantsCell,
      align: 'left'
    },
    {
      label: 'Rental Items type',
      cellClassName: classes.activityTypeCell,
      align: 'left'
    },
    {
      label: 'Product code',
      cellClassName: classes.productCodeCell,
      align: 'left'
    },
    {
      label: 'Status',
      cellClassName: classes.startingPointCell,
      align: 'left'
    },
    { label: '', align: 'right' }
  ];
};

function RentalItemsList({ businessOwner }) {
  const classes = useStyles();
  const history = useHistory();
  const [t] = useTranslation();

  const [page, setPage] = React.useState(0);

  const { data, loading: isLoading, refetch } = useQuery(RENTAL_ITEMS, {
    variables: {
      page: page,
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  React.useEffect(() => {
    refetch();
  }, []);

  const onPageChangeHandler = (e, page) => {
    refetch({
      page: page - 1
    });
    setPage(page - 1);
  };

  return (
    <>
    <CircularLoader
        isLoading={isLoading}
        loaderClassName={classes.loaderClassName}
    />
    <TableContainer component="div" classes={{ root: classes.container }}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {headingsConfig(classes).map(heading => (
              <TableCell
                key={heading.label}
                align={heading.align}
                className={classNames(
                  classes.tableCell,
                  classes.headTableCell,
                  heading.cellClassName
                )}
              >
                <Typography variant="h3" className={classes.heading}>
                  {t(heading.label)}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.rentalItems &&
            data.rentalItems.map(rentalItems => (
              <TableRow
                key={rentalItems.id}
                classes={{ root: classes.tableRow }}
                onClick={() => {if (rentalItems.status?.status?.toLowerCase() === "available") {
                          history.push(`/rental-items/${rentalItems.id}/book`);
                        }}}
              >
                <TableCell
                  className={classNames(classes.tableCell, classes.imgCell)}
                  component="th"
                  scope="row"
                >
                  <div className={classes.imageWrapper}>
                    {rentalItems.photo && (
                      <img
                        src={rentalItems.photo}
                        alt=""
                        className={classes.image}
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.nameCell)}
                  align="left"
                >
                  {rentalItems.title}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.participantsCell
                  )}
                  align="left"
                >
                  {rentalItems.availableUnits}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.activityTypeCell
                  )}
                  align="left"
                >
                 {rentalItems.itemsType.type}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.productCodeCell
                  )}
                  align="left"
                >
                  {rentalItems.productCode}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.startingPointCell
                  )}
                  align="left"
                >
                  {rentalItems.status.status}
                </TableCell>
               
                <TableCell className={classes.tableCell} align="left">
                  {rentalItems.status?.status.toLowerCase() === "available" && (
                    <Button
                      onClick={e => {
                        e.stopPropagation();
                        history.push(`/rental-items/${rentalItems.id}/book`);
                      }}
                      variant="outlined"
                      color="primary"
                      classes={{ root: classes.buttonRoot }}
                    >
                      {t('Book')}
                    </Button>
                  )}
                </TableCell>

              </TableRow>
            ))}
        </TableBody>
      </Table>

      {data && (
        <Pagination
          page={page + 1}
          count={data.numberOfRentalItemsPages}
          onChange={onPageChangeHandler}
          amount={`${page * 11 + 1}-${Math.min(
          (page + 1) * 11,
          data.rentalItemsOverview.rentalItems.total
          )}`}
          total={data.rentalItemsOverview.rentalItems.total}
        />
      )}
    </TableContainer>
    </>
  );
}

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(RentalItemsList);
